import React, { ReactElement } from 'react';
import ErrorIcon from '../../icons/error-icon';
import FormatService from '../../services/format-service';
import useStylesIconBlockError from './icon-block-error.styles';

const IconBlockError: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isDisabled,
    className,
  } = props;

  const { classes } = useStylesIconBlockError();

  return (
    <ErrorIcon
      className={FormatService.formatClassNames(
        !isDisabled ? classes.iconBlockError : undefined,
        className,
      )}
    />
  );
});

export default IconBlockError;
